(function(){
  function init(){
    const select = document.querySelector('.product__select');
    if(!select) return;

    function bucketBadge(pct){
      if(pct >= 50) return 50;
      if(pct >= 40) return 40;
      if(pct >= 30) return 30;
      if(pct >= 20) return 20;
      if(pct >= 10) return 10;
      return null;
    }

    function updatePriceUI(){
      const opt = select.options[select.selectedIndex];
      if(!opt) return;

      const priceText = opt.dataset.price || '';
      const compareText = opt.dataset.regularPrice || opt.dataset.comparePrice || '';
      const priceCents = parseInt(opt.dataset.priceCents || '0', 10);
      const compareCents =
        parseInt(opt.dataset.regularCents || '0', 10) ||
        parseInt(opt.dataset.compareCents || '0', 10) ||
        0;

      // discount percentage
      let discountPct = 0;
      if(compareCents > priceCents && compareCents > 0){
        discountPct = Math.round(((compareCents - priceCents) * 100) / compareCents);
      }
      const badgePct = bucketBadge(discountPct);

      // current price
      document.querySelectorAll('[data-price-current]').forEach(el => {
        el.textContent = priceText;
      });

      // compare / strikethrough price
      document.querySelectorAll('[data-price-compare]').forEach(el => {
        if(compareCents > priceCents && compareText){
          el.textContent = compareText;
          el.style.display = '';
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });

      // promo badge
      document.querySelectorAll('[data-promo-badge]').forEach(wrapper => {
      const img = wrapper.querySelector('img');
      if(!img) return;

      let url = '';
      if (badgePct) {
        url = wrapper.getAttribute('data-badge-' + badgePct) || ''; // use attributes directly (more reliable than dataset)
      }

      if (url) {
        img.src = url;
        img.alt = badgePct + '% off';
        wrapper.classList.add('is-visible');
        wrapper.style.display = 'block';       // override inline display:none
        wrapper.style.visibility = 'visible';  // belt-and-braces
      } else {
        img.src = '';
        img.alt = '';
        wrapper.classList.remove('is-visible');
        wrapper.style.display = 'none';
      }
    });

    }

    // Initial run
    updatePriceUI();

    // Normal event hooks
    select.addEventListener('change', updatePriceUI);
    document.addEventListener('variant:change', updatePriceUI);

    // --- Robust silent-variant watcher ---
    let lastValue = select.value;

    // Catch themes that set select.value without firing change
    setInterval(() => {
      if(select.value !== lastValue){
        lastValue = select.value;
        updatePriceUI();
      }
    }, 150);

    // Catch themes that toggle <option selected>
    const mo = new MutationObserver(() => {
      if(select.value !== lastValue){
        lastValue = select.value;
        updatePriceUI();
      }
    });
    mo.observe(select, { subtree:true, attributes:true, attributeFilter:['selected'] });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
